<template>
  <div class="deactivateDialog">
    <el-dialog
      title="系统提醒"
      :visible.sync="open"
      :close-on-click-modal="true"
      width="480px"
    >
      <div class="deactivateDialog-box">
        <div class="prompt">
          确认停用&nbsp;&nbsp;<span>{{ groupName }}</span>&nbsp;&nbsp;患者分组？
        </div>
      </div>
      <div class="btn-box">
        <el-button @click="Confirm" class="btn" type="primary">确 认</el-button>
        <el-button @click="Cancel" class="btn">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "deactivateDialog",
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    doctorID: {
      type: String,
      default: () => "",
    },
    groupId: {
      type: String,
      default: () => "",
    },
    groupName: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods:{
    async Confirm(){
      try{
        const res = await this.$post("group/toggleStatus",{
          docId: this.doctorID,
          groupId: this.groupId,
          status: 1,
        })
        if (!res) return false;
        // eslint-disable-next-line no-unused-vars
        const { data } = res;
        this.open = false;
        this.$emit("confirm");
      }catch (e) {
        console.error(e);
      }
    },
    Cancel(){
        this.open = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.deactivateDialog {
  .deactivateDialog-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .prompt {
      font-size: 16px;
      color: #3d3d3d;
    }
  }
  .btn-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #EBECF0;
    gap: 20px;
    .btn{
        width: 90px;
        height: 36px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
  }
}
::v-deep .el-dialog__header {
  background-color: #1a7cf2;
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    font-size: 20px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
</style>
